import styled, { css } from 'styled-components';

import Input from '@polyai/ui/components/atoms/Input';
import Select from '@polyai/ui/components/atoms/Select';
import themeColors from '@polyai/ui/styles/config/colors';
import themeSpacing from '@polyai/ui/styles/config/spacing';
import text from '@polyai/ui/styles/config/text';

import Password from 'components/molecules/PasswordInput';

const FORM_SELECT_MIN_WIDTH = 120;

export const FormTextInput = styled(Input)<{ $inline?: boolean }>`
  width: 100%;
  font-weight: ${({ theme }) => theme.text.weight.regular};

  ${({ inverse }) =>
    !inverse &&
    css`
      background-color: ${themeColors.background};
    `};

  ${({ $inline }) =>
    $inline &&
    css`
      display: inline-block;

      padding: ${themeSpacing.xxs1} 0;

      border: none;
      border-bottom: 1px solid ${themeColors.borderStrong};
      border-radius: 0;
    `}
`;

export const FormSelect = styled(Select)`
  min-width: ${FORM_SELECT_MIN_WIDTH}px;

  h3 {
    font-size: ${text.size.body.regular} !important;
    font-weight: ${text.weight.regular} !important;
  }
` as typeof Select;

export const PasswordInput = styled(Password)`
  width: 100%;
  font-weight: ${({ theme }) => theme.text.weight.regular};
`;
